import * as React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import get from 'lodash/get';

import { TextField as MuiTextField, TextFieldProps as MuiTextFieldProps } from '@mui/material';

import { theme } from '@itp/talent/theme';

type TextFieldProps = { errorMessage?: any; frost?: boolean } & MuiTextFieldProps;

export const TextField: React.FC<TextFieldProps> = ({
  errorMessage = '',
  name = 'textField',
  size = 'medium',
  ...props
}) => {
  const {
    control,
    formState: { defaultValues, errors, isSubmitting },
    register,
  } = useFormContext();

  return (
    <Controller
      render={({ field }) => (
        <MuiTextField
          {...props}
          {...field}
          {...register(name)}
          disabled={isSubmitting || props.disabled}
          error={!!get(errors, name)?.message || !!errorMessage}
          fullWidth
          helperText={(get(errors, name)?.message as string) || errorMessage || props.helperText}
          size={size}
          sx={{ ...props?.sx, borderColor: theme.palette.secondary.main }}
        />
      )}
      control={control}
      defaultValue={defaultValues?.[name]}
      name={name}
    />
  );
};
